export const FOCUSABLE_ELEMENTS = ':where(a, button, input:not([type="hidden"]), select, textarea, iframe, [tabindex], [contentEditable="true"])'

export default class A11y {
    static hoverEnabled() {
        return window.matchMedia('(hover: hover)').matches
    }

    static motionEnabled() {
        return window.matchMedia('(hover: hover)').matches
    }

    static getFocusableElements(element) {
        return Array.from(element.querySelectorAll(FOCUSABLE_ELEMENTS)).filter(el => el.offsetParent)
    }
}